<div class="parent">
  <div
    *ngFor="let channel of channelsTaskListConfigs"
    (click)="selectChannel(channel)"
    class="channel"
    [class.selected]="taskListConfiguration.channelQueueId === channel.queueId">
    <ng-container *ngIf="channel.counterIndex !== undefined">
      <ng-container *ngIf="counters.length && channel.counter; else loading">
        <div>
          <div
            class="counter"
            [ngClass]="{ zero: !channel.counter[0] }"
            [innerHTML]="channel.counter[0] | truncateCounter"
            [attr.data-testid]="'counters-' + channel.queueId"></div>
        </div>
      </ng-container>
      <ng-template #loading>
        <div>
          <div class="counter zero">...</div>
        </div>
      </ng-template>
    </ng-container>
    <div class="alc-ellipsis">
      <img
        *ngIf="channel.typeString !== 'all'"
        class="icon"
        [src]="'assets/img/site_icon/v2/' + channel.typeString + '.png'" />
      <span class="name">{{ channel.name }}</span>
    </div>
  </div>
</div>
